export const getExpenseHistory = ()=>{

    return([

        {
            name: "Frozen yoghurt",
            purchased: 200,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 23
        },
        {
            name: "Ice cream sandwich",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Storm Energy Drink",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Frytol Sachet 35g",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Nestle Nido",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Frozen yoghurt",
            purchased: 200,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 23
        },
        {
            name: "Ice cream sandwich",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Storm Energy Drink",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Frytol Sachet 35g",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Nestle Nido",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Frozen yoghurt",
            purchased: 200,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 23
        },
        {
            name: "Ice cream sandwich",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Storm Energy Drink",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Frytol Sachet 35g",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Nestle Nido",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Storm Energy Drink",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Frytol Sachet 35g",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        {
            name: "Nestle Nido",
            purchased: 100,
            sold: 26,
            inStock: 74,
            valuation: 1200,
            expectedRevenue: 1800,
            daysToExpire: 120
        },
        
    ])
    
}

export const getExpenseHistoryLabels = ()=>(["Name", "Purchased", "Sold", "In stock", "Valuation", "Expected revenue", ])